var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFanxoStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "84 76 368 356",
    role: "img",
    "aria-labelledby": titleId,
    shapeRendering: "geometricPrecision",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "fanxoStarTitle"
  }, "Fanxo star mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "fanxoStarTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "259.19,216.46 124.01,194.85 98.77,160.47 220.98,179.28 245.91,146.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.3,218.47 296.62,249.47 268.92,117.06 293.09,85.69 318.09,203.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.04,301.04 328.65,340.49 276.56,291.23 398.75,231.97 398.78,231.97 436.66,245.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.94,421.55 237.33,335.03 197.2,346.24 228.37,285.35 329.29,380.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.82,239.52 160.8,356.39 121.33,367.4 172.29,260.69 147.94,227.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanxoStar);
export default __webpack_public_path__ + "static/media/FanxoStar.37495f1449c57e6e306a2977b4a2dd13.svg";
export { ForwardRef as ReactComponent };